/**
 * Meta description length rule (SEO audit, Oct 2026). Shared by api/ssr.ts and
 * the SEO component, like seoTitle.ts, so server and Helmet output match.
 */
export const MAX_META_DESCRIPTION_LENGTH = 155;

/**
 * Keep descriptions at or under 155 characters. Prefer ending on a full
 * sentence; otherwise cut at a word boundary and add an ellipsis.
 */
export function clampMetaDescription(description: string): string {
  const text = description.replace(/\s+/g, ' ').trim();
  if (text.length <= MAX_META_DESCRIPTION_LENGTH) return text;
  const window = text.slice(0, MAX_META_DESCRIPTION_LENGTH);
  const sentenceEnd = Math.max(window.lastIndexOf('. '), window.lastIndexOf('? '), window.lastIndexOf('! '));
  if (sentenceEnd >= 70) return window.slice(0, sentenceEnd + 1);
  const cut = text.slice(0, MAX_META_DESCRIPTION_LENGTH - 1);
  const space = cut.lastIndexOf(' ');
  return `${(space > 0 ? cut.slice(0, space) : cut).replace(/[\s,;:–—-]+$/, '')}…`;
}
